import React from 'react';
import { WithTranslation } from 'next-i18next';

import { withTranslation } from 'lib/i18n';

import bracket from '../../images/bracket.svg';

import CostsWrap from './styled/CostsWrap';
import Cost from './styled/Cost';

const Costs: React.FC<WithTranslation> = props => (
  <CostsWrap>
    <ul>
      {['1', '2', '3', '4', '5', '6'].map(key => (
        <li key={key}>
          {props.t(`business.index.case_study.economics.costs.${key}`)}
        </li>
      ))}
    </ul>

    <img src={bracket} alt="" />

    <div>
      <Cost>
        <strong>{props.t('business.index.case_study.economics.cost')}</strong>
        <small>{props.t('currency')}</small>
      </Cost>
    </div>
  </CostsWrap>
);

export default withTranslation('pages')(Costs);
